import React from "react";
import Breadcrumbs from "../../../reusebale/breadcrumbs";
import InfoSection from "../../broadcast/broadcastDetail/infoSection";
import Recipent from "../../broadcast/broadcastDetail/recipent";

const BroadCastDetail = ({ onBack, detail }) => {

  return (
    <div className="mt-4">
      <Breadcrumbs
        detail={detail}
        classes={`text-darkColor font-popinsSemiBold text-xl`}
        subheading="Broadcasts Details"
        content="LID-000199581"
        onBack={onBack}
        recordId={`BROD-${detail?._id?.slice(0, 10)}`}
      />
      <InfoSection
        detail={detail}
      />
      <Recipent
        detail={detail}
      />


    </div>
  );
};

export default BroadCastDetail;
